



































































































export default function (Component) {
  Component.options.__source = "src/components/d2-container-objinput-selects/index.vue"
}
